<template>
  <div>
    <div class="warp">
      <!-- 面包屑 -->
      <breadcrumb :back="true" :crubList="[{name:'债权融资管理'},{name:'债权融资需求列表',goback:true},{name:'推荐债权产品'}]" :title="'推荐债权产品'"  ref="breadcrumb"/>
      <!-- 查询条件 -->
      <div class="retrieve border" ref="condition">
        <div class="left">
          <div class="child">
            <span class="name">贷款类型</span>
            <el-select v-model="sendInfoOne.loanType" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in loanType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="child super_select">
            <span class="name">检索</span>
            <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
          </div>
          <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
        </div>
      </div>
      <div class="button_box">
        <el-button type="primary" size="small" @click="backInform" class="retrievalBtn">取消</el-button>
        <el-button type="primary" size="small" @click="sureButton" class="retrievalBtn">确认</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :data="tableData"
        ref="table"
        :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="checkboxT"></el-table-column>
        <el-table-column prop="id" show-overflow-tooltip  label="债权产品ID"></el-table-column>
        <el-table-column prop="debtProductName" show-overflow-tooltip  label="产品名称">
          <template slot-scope="scope">
            <el-link type="primary" @click="inform(scope.row)">{{scope.row.debtProductName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="loanTypeValue" show-overflow-tooltip  label="贷款类型"></el-table-column>
        <el-table-column prop="bankName" show-overflow-tooltip  label="银行名称"></el-table-column>
        <el-table-column prop="releaseAccount" show-overflow-tooltip  label="发布账号"></el-table-column>
        <el-table-column prop="recommend" show-overflow-tooltip  label="推荐状态">
          <template slot-scope="scope">
            <span v-if="scope.row.recommend===0">未推荐</span>
            <span v-else>已推荐</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="sendInfoOne.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="申请信息" :visible.sync="dialogInfo" width="50%">
      <div class="basic">
        <div class="boxChild">
          <div class="basisTitle">债权产品信息</div>
          <div class="child">
            <div class="name">银行名称：</div>
            <div class="content">{{checkDetails.bankName}}</div>
          </div>
          <div class="child">
            <div class="name">产品名称：</div>
            <div class="content">{{checkDetails.debtProductName}}</div>
          </div>
          <div class="child">
            <div class="name">贷款类型：</div>
            <div class="content">
              <template v-if="checkDetails.loanTypeList.length>1">
                <span v-for="(item,index) in checkDetails.loanTypeList" :key="index">{{item}}/</span>
              </template>
              <template v-else>
                <span>{{checkDetails.loanTypeList[0]}}</span>  
              </template>
            </div>
          </div>
          <div class="child">
            <div class="name">最高额度：</div>
            <div class="content">{{checkDetails.maxAmount}}</div>
          </div>
          <div class="child">
            <div class="name">最低额度：</div>
            <div class="content">{{checkDetails.minAmount}}</div>
          </div>
          <div class="child">
            <div class="name">贷款期限：</div>
            <div class="content">{{checkDetails.loanTerm}}</div>
          </div>
          <div class="child">
            <div class="name">担保方式：</div>
            <ol>
              <li
                class="content"
                v-for="(item,index) in checkDetails.guaranteeWay"
                :key="index"
              >{{item.value}}</li>
            </ol>
          </div>
          <div class="child">
            <div class="name">年利率：</div>
            <div class="content">{{checkDetails.yearInterest}}</div>
          </div>
          <div class="child">
            <div class="name">产品介绍：</div>
            <div class="content super_p" v-html="checkDetails.productIntro"></div>
          </div>
          <div class="child">
            <div class="name">贷款须知：</div>
            <ul>
              <li
                class="content super_ctn" :style="`align-items:${item.content.indexOf('<p') !== -1?'flex-start':'center'}`"
                v-for="(item,index) in checkDetails.loanKnown"
                :key="index"
              > {{item.sort}}.<span v-html="item.content" class="super_p" v-if="item.content.indexOf('<p') !== -1"></span><span v-else style="line-height:18px">{{item.content}}</span></li>
            </ul>
          </div>
          <div class="attachment">
            <div class="name">附件：</div>
            <ul class="content">
              <li v-for="(item,index) in checkDetails.fileList" :key="index">
                <span>{{item.fileName}}</span>
                <i class="el-icon-download" @click="downLoad(item)"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumb from "../../components/breadcrumb";
import timeMixins from "@/mixins/timeFormat";
import Regular from "@/mixins/regular.js";
import {onDownload} from "@/utils/common";
export default {
  mixins: [timeMixins],
  components: {
    breadcrumb
  },
  data() {
    return {
      loading:false,
      bHeight: void 0,
      dataId: "",
      authorities: JSON.parse(window.localStorage.getItem("authorities")),
      options: [
        {
          value: "debtProductName",
          label: "产品名称"
        },
        {
          value: "bankName",
          label: "银行名称"
        },
        {
          value: "userName",
          label: "发布账号"
        }
      ], //检索下拉
      getSelect: "", //检索下拉的值
      getValue: "", //检索输入框的值
      sendInfoOne: {
        currentPage: 1, //当前页
        pageSize: 10, //页条数
        loanType: null, //贷款类型
        id: "", //申请id
        userName: "", //发布账号
        bankName: "", //银行名称
        debtProductName: "", //产品名称
        property: null, //排序字段
        direction: null //排序方式
      }, //检索提交数据
      tableData: [], //表格数据
      currentPage: 1, //当前页
      loanType: [], //贷款类型,
      totalSize: null, //总条数
      dialogInfo: false,
      checkDetails: {
        bankName: "", //账号
        debtProductName: "", //产品名称
        loanTypeList: [], //贷款类型
        maxAmount: "", //最高额度
        minAmount: "", //最低额度
        loanTerm: "", //贷款期限
        guaranteeWay: [], //担保方式
        loanKnown: [],
        fileList: [], //附件列表
        yearInterest: "", //年利率
        productIntro: "" //产品介绍
      },
      multipleSelection: []
    };
  },
  computed: {
    errors() {
      return this.$vuerify.$errors; // 错误信息会在 $vuerify.$errors 内体现
    }
  },
  methods: {
     download({fileName,filePath}){
      const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
    },
    doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
    //     table选择数据
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    sureButton() {
      let arr = [];
      for (let item of this.multipleSelection) {
        arr.push(item.id);
      }
      this.$axiosc
        .put(
          "backstage/myDeptNeeds/recommend/product",
          this.$qs.stringify({ id: this.dataId, recommendProductIds: arr })
        )
        .then(r => {
          if (r.code == 200) {
            this.$message({
              message: "推荐成功！",
              type: "success"
            });
            this.dialogAudit = false;
            this.getData();
          } else {
            this.$alert(r.msg);
          }
        });
    },
    backInform() {
      this.$router.back();
    },
    checkboxT(row, rowIndex) {
      if (row.recommend == 1) {
        return false; //禁用
      } else {
        return true; //不禁用
      }
    },
    //   查看产品信息
    inform(row) {
      this.$axiosc.get("backstage/debt/financing/details/" + row.id).then(r => {
        if (r.code == 200) {
          this.checkDetails = r.data;
          this.dialogInfo = true;
        } else {
          this.$alert(r.msg);
        }
      });
    },
    //查询
    retrieval: function() {},
    //获取字典
    getDic: function() {
      this.$axiosz.get("backstage/sysDict/isShow/LOAN_TYPE").then(r => {
        //贷款类型
        if (r.code == 200) {
          this.loanType = r.data;
        }
      });
    },
    getData() {
      let obj = Object.assign({}, this.sendInfoOne);
      if (this.dateS && this.dateS.length > 0) {
        obj.startDate = this.dateS[0];
        obj.endDate = this.dateS[1];
      }
      if (this.getSelect && this.getValue) {
        obj[this.getSelect] = this.getValue;
      }
      this.loading = false
      this.$axiosc.get("backstage/myDeptNeeds/debt/financing/myDeptId/" + this.dataId, {
          params: obj
        })
        .then(r => {
          this.loading = false
          if (r.code == 200) {
            this.tableData = r.data.content;
            this.totalSize = r.data.totalElements;
          } else {
            this.$alert(r.msg);
          }
        }).catch(e=>{
          this.loading = false
        })
    },
    //分页功能模块
    //切换每页显示条数
    handleSizeChange(val) {
      this.sendInfoOne.pageSize = val;
      this.getData();
    },
    //切换页码
    handleCurrentChange(val) {
      this.sendInfoOne.currentPage = val;
      this.getData();
    }
  },
  mounted() {
    const that = this
    if (that.$route.query.id) {
      that.dataId = that.$route.query.id;
    }
    that.getDic();
    that.getData();
      let bh = 44 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60 + (that.$refs.condition?that.$refs.condition.offsetHeight:0)
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60 + (that.$refs.breadcrumb?that.$refs.breadcrumb.$el.offsetHeight:0) 
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  }
};
</script>
<style  scoped>
.button_box {
  margin-bottom: 20px;
  padding-top: 20px;
  border-top: 1px solid #ececec;
  /* text-align: center; */
}
.basisTitle,.child{
  margin-bottom: 10px;
}
.super_ctn{
  display: flex;
  align-items: flex-start;
 
  
}
</style>